export enum SentencePartType {
	brandName = 'brand-name',
	comma = 'comma',
	countryName = 'country-name',
	monetaryAmount = 'monetary-amount',
	packageName = 'package-name',
	text = 'text',
	tooltip = 'tooltip',
}

export type SentencePart =
	| { type: SentencePartType.brandName; text: string }
	| { type: SentencePartType.comma }
	| { type: SentencePartType.countryName; name: string; alpha2: string }
	| { type: SentencePartType.monetaryAmount; amount: string; currency: string }
	| { type: SentencePartType.packageName; text: string }
	| { type: SentencePartType.text; text: string }
	| { type: SentencePartType.tooltip; text: string; tooltip: string };

function arePartsEqual(
	part: {
		type: SentencePartType;
		text?: string;
		amount?: string;
		alpha2?: string;
		currency?: string;
		tooltip?: string;
	},
	otherPart: {
		type: SentencePartType;
		text?: string;
		amount?: string;
		alpha2?: string;
		currency?: string;
		tooltip?: string;
	}
): boolean {
	if (part.type !== otherPart.type) {
		return false;
	}

	switch (part.type) {
		case SentencePartType.brandName:
		case SentencePartType.packageName:
		case SentencePartType.text:
			return part.text === otherPart.text;

		case SentencePartType.comma:
			return true;

		case SentencePartType.countryName:
			return part.alpha2 === otherPart.alpha2;

		case SentencePartType.monetaryAmount:
			return part.amount === otherPart.amount && part.currency === otherPart.currency;

		case SentencePartType.tooltip:
			return part.text === otherPart.text && part.tooltip === otherPart.tooltip;

		default:
			return false;
	}
}

export default class Sentence {
	parts: SentencePart[];

	constructor(parts: SentencePart[]) {
		this.parts = parts;
	}

	isSimilar(otherSentence: Sentence): boolean {
		if (this.parts.length !== otherSentence.parts.length) {
			return false;
		}
		return (
			this.parts.find(
				(part, i) => part.type !== SentencePartType.packageName && !arePartsEqual(part, otherSentence.parts[i])
			) === undefined
		);
	}
}
